import React from 'react';

import {createRoot} from 'react-dom/client';

import App from '@components/App';

const container = document.querySelector('#root');
if (!container) {
  throw new Error('unable to find a container');
}
const root = createRoot(container);
root.render(<App />);
